import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {removeNonDigits} from "../../../../../../common/src/util/lib";
import * as AdminActions from "../../../../actions/admin";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class GeneralLabels extends React.Component {
    getLabelConfig = (props, config) => props.admin.generalSection && props.admin.generalSection.Config && typeof(props.admin.generalSection.Config.Labels) !== 'undefined' && typeof(props.admin.generalSection.Config.Labels[config]) !== 'undefined' && props.admin.generalSection.Config.Labels[config] !== null ? String(props.admin.generalSection.Config.Labels[config]) : '';

    constructor(props) {
        super(props);
        this.state = Object.assign({
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            fromMember: '',
            toMember: '',
            showMemberNo: false,
            showLogo: false,
            clubChairman: false,
            clubCashier: false,
            clubItContact: false,
            clubReleas: false,
            sectionChairman: false,
            sectionCashier: false,
            members: false,
            magazineByPost: false,
            format: 'labels',
            leftMargin: this.getLabelConfig(props, 'leftMargin'),
            topMargin: this.getLabelConfig(props, 'topMargin'),
            labelLeftMargin: this.getLabelConfig(props, 'labelLeftMargin'),
            labelTopMargin: this.getLabelConfig(props, 'labelTopMargin'),
            labelHeight: this.getLabelConfig(props, 'labelHeight'),
            labelWidth: this.getLabelConfig(props, 'labelWidth'),
            rowCount: this.getLabelConfig(props, 'rowCount'),
            columnCount: this.getLabelConfig(props, 'columnCount'),
            lineHeight: this.getLabelConfig(props, 'lineHeight'),
            fontSize: this.getLabelConfig(props, 'fontSize'),
        });
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getGeneral());
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            leftMargin: this.getLabelConfig(nextProps, 'leftMargin'),
            topMargin: this.getLabelConfig(nextProps, 'topMargin'),
            labelLeftMargin: this.getLabelConfig(nextProps, 'labelLeftMargin'),
            labelTopMargin: this.getLabelConfig(nextProps, 'labelTopMargin'),
            labelHeight: this.getLabelConfig(nextProps, 'labelHeight'),
            labelWidth: this.getLabelConfig(nextProps, 'labelWidth'),
            rowCount: this.getLabelConfig(nextProps, 'rowCount'),
            columnCount: this.getLabelConfig(nextProps, 'columnCount'),
            lineHeight: this.getLabelConfig(nextProps, 'lineHeight'),
            fontSize: this.getLabelConfig(nextProps, 'fontSize'),
        })
    }

    fields = [];
    render() {
        return <div className="general-labels reports-inner-box report-options">
            <table className="options-table" style={{maxWidth: '800px'}}>
                <tbody>
                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                    <td><label htmlFor="fromSection">Fra sektion</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="fromSection" id="fromSection" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.fromSection}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[0] = instance; }}
                    /></td>
                    <td><label htmlFor="toSection">Til sektion</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="toSection" id="toSection" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.toSection}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[1] = instance; }}
                    /></td>
                </tr> : null}
                {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <tr>
                    <td><label htmlFor="fromClub">Fra forening</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="fromClub" id="fromClub" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.fromClub}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          onBlur={() => {
                                              this.fields[2].setState({focused: false, visited: true});
                                              if (/^[0-9]{1,2}$/.test(this.state.fromClub)) this.setState({fromClub: this.state.fromClub.padStart(3, '0'), toClub: this.state.toClub === '' ? this.state.fromClub.padStart(3, '0') : this.state.toClub});
                                              else if (/^[0-9]{3}$/.test(this.state.fromClub) && this.state.toClub === '') this.setState({toClub: this.state.fromClub});
                                          }}
                                          ref={instance => { this.fields[2] = instance; }}
                    /></td>
                    <td><label htmlFor="toClub">Til forening</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="toClub" id="toClub" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.toClub}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          onBlur={() => {
                                              this.fields[3].setState({focused: false, visited: true});
                                              if (/^[0-9]{1,2}$/.test(this.state.toClub)) this.setState({toClub: this.state.toClub.padStart(3, '0')});
                                          }}
                                          ref={instance => { this.fields[3] = instance; }}
                    /></td>
                </tr>}
                <tr>
                    <td><label htmlFor="fromMember">Fra medlem</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="fromMember" id="fromMember" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.fromMember}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          onBlur={() => {
                                              this.fields[4].setState({focused: false, visited: true});
                                              if (/^[0-9]{1,5}$/.test(this.state.fromMember)) this.setState({fromMember: this.state.fromMember.padStart(6, '0'), toMember: this.state.toMember === '' ? this.state.fromMember.padStart(6, '0') : this.state.toMember});
                                              else if (/^[0-9]{6}$/.test(this.state.fromMember) && this.state.toMember === '') this.setState({toMember: this.state.fromMember});
                                          }}
                                          ref={instance => { this.fields[4] = instance; }}
                    /></td>
                    <td><label htmlFor="toMember">Til medlem</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="toMember" id="toMember" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.toMember}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          onBlur={() => {
                                              this.fields[5].setState({focused: false, visited: true});
                                              if (/^[0-9]{1,5}$/.test(this.state.toMember)) this.setState({toMember: this.state.toMember.padStart(6, '0')});
                                          }}
                                          ref={instance => { this.fields[5] = instance; }}
                    /></td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <input id="showMemberNo" name="showMemberNo" type="checkbox" checked={this.state.showMemberNo} onClick={e => this.setState({showMemberNo: !this.state.showMemberNo})}/> <label htmlFor="showMemberNo">Vis medlemsnumre</label>
                    </td>
                    <td colSpan={2}>
                        <input id="showLogo" name="showLogo" type="checkbox" checked={this.state.showLogo} disabled={this.state.format === 'labels'} onClick={e => this.setState({showLogo: !this.state.showLogo})}/> <label htmlFor="showLogo" className={this.state.format === 'labels' ? 'disabled' : ''}>Vis logo</label>
                    </td>
                </tr>

                <tr className="separator"/>
                <tr>
                    <td colSpan={4}><label>Personkategorier</label></td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <input id="clubChairman" name="clubChairman" type="checkbox" checked={this.state.clubChairman} onClick={e => this.setState({clubChairman: !this.state.clubChairman})}/> <label htmlFor="clubChairman">Foreningsformænd</label>
                    </td>
                    <td colSpan={2}>
                        <input id="clubCashier" name="clubCashier" type="checkbox" checked={this.state.clubCashier} onClick={e => this.setState({clubCashier: !this.state.clubCashier})}/> <label htmlFor="clubCashier">Foreningskasserere</label>
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <input id="clubItContact" name="clubItContact" type="checkbox" checked={this.state.clubItContact} onClick={e => this.setState({clubItContact: !this.state.clubItContact})}/> <label htmlFor="clubItContact">Edb-kontakter</label>
                    </td>
                    <td colSpan={2}>
                        <input id="clubReleas" name="clubReleas" type="checkbox" checked={this.state.clubReleas} onClick={e => this.setState({clubReleas: !this.state.clubReleas})}/> <label htmlFor="clubReleas">Kontrolformænd</label>
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <input id="sectionChairman" name="sectionChairman" type="checkbox" checked={this.state.sectionChairman} onClick={e => this.setState({sectionChairman: !this.state.sectionChairman})}/> <label htmlFor="sectionChairman">Sektionsformænd</label>
                    </td>
                    <td colSpan={2}>
                        <input id="sectionCashier" name="sectionCashier" type="checkbox" checked={this.state.sectionCashier} onClick={e => this.setState({sectionCashier: !this.state.sectionCashier})}/> <label htmlFor="sectionCashier">Sektionskasserere</label>
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <input id="members" name="members" type="checkbox" checked={this.state.members} onClick={e => this.setState({members: !this.state.members})}/> <label htmlFor="members">Medlemmer</label>
                    </td>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td colSpan={2}>
                        <input id="magazineByPost" name="magazineByPost" type="checkbox" checked={this.state.magazineByPost} onClick={e => this.setState({magazineByPost: !this.state.magazineByPost})}/> <label htmlFor="magazineByPost">Brevduen med post</label>
                    </td> : null}
                </tr>

                <tr className="separator"/>
                <tr>
                    <td><label htmlFor="format">Format</label></td>
                    <td colSpan={3}>
                        <UserFieldElement
                            dataType={UserFieldDataType.enum} placeholder={false} className="field100" containerClassName="display-inline-block"
                            name="format" id="format" value={this.state.format}
                            options={[
                                {key: 'labels', value: 'Labels'},
                                {key: 'c4', value: 'C4'},
                                {key: 'c5', value: 'C5'},
                            ]}
                            autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                            ref={instance => { this.fields[6] = instance; }}
                            onChange={this.onStandardFieldChange}
                        />
                    </td>
                </tr>

                <tr className="separator"/>
                <tr>
                    <td><label htmlFor="leftMargin" className={this.state.format === 'labels' ? '' : 'disabled'}>Side venstre margen</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="leftMargin" id="leftMargin" value={this.state.leftMargin} disabled={this.state.format !== 'labels'}
                                          title="Afstand fra venstre af arket til første label, målt i mm"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[7] = instance; }}
                    /></td>
                    <td><label htmlFor="topMargin" className={this.state.format === 'labels' ? '' : 'disabled'}>Side topmargen</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="topMargin" id="topMargin" value={this.state.topMargin} disabled={this.state.format !== 'labels'}
                                          title="Afstand fra toppen af arket til første label, målt i mm"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[8] = instance; }}
                    /></td>
                </tr>
                <tr>
                    <td><label htmlFor="labelLeftMargin" className={this.state.format === 'labels' ? '' : 'disabled'}>Labels venstre margen</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="labelLeftMargin" id="labelLeftMargin" value={this.state.labelLeftMargin} disabled={this.state.format !== 'labels'}
                                          title="Indrykning af tekst fra venstre på label, målt i mm"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[9] = instance; }}
                    /></td>
                    <td><label htmlFor="labelTopMargin" className={this.state.format === 'labels' ? '' : 'disabled'}>Labels topmargen</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="labelTopMargin" id="labelTopMargin" value={this.state.labelTopMargin} disabled={this.state.format !== 'labels'}
                                          title="Afstand fra toppen af label til tekst, målt i mm"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[10] = instance; }}
                    /></td>
                </tr>
                <tr>
                    <td><label htmlFor="labelHeight" className={this.state.format === 'labels' ? '' : 'disabled'}>Labelhøjde</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="labelHeight" id="labelHeight" value={this.state.labelHeight} disabled={this.state.format !== 'labels'}
                                          title="Højde af label inklusive afstand til næste label, målt i mm"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[11] = instance; }}
                    /></td>
                    <td><label htmlFor="labelWidth" className={this.state.format === 'labels' ? '' : 'disabled'}>Labelbredde</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="labelWidth" id="labelWidth" value={this.state.labelWidth} disabled={this.state.format !== 'labels'}
                                          title="Bredde af label inklusive afstand til næste label, målt i mm"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[12] = instance; }}
                    /></td>
                </tr>
                <tr>
                    <td><label htmlFor="rowCount" className={this.state.format === 'labels' ? '' : 'disabled'}>Rækker pr. ark</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="rowCount" id="rowCount" value={this.state.rowCount} disabled={this.state.format !== 'labels'}
                                          title="Antal label-rækker på et ark, under hinanden"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[13] = instance; }}
                    /></td>
                    <td><label htmlFor="columnCount" className={this.state.format === 'labels' ? '' : 'disabled'}>Kolonner pr. ark</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="columnCount" id="columnCount" value={this.state.columnCount} disabled={this.state.format !== 'labels'}
                                          title="Antal label-kolonner på et ark, ved siden af hinanden"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[14] = instance; }}
                    /></td>
                </tr>
                <tr>
                    <td><label htmlFor="lineHeight" className={this.state.format === 'labels' ? '' : 'disabled'}>Liniehøjde</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="lineHeight" id="lineHeight" value={this.state.lineHeight} disabled={this.state.format !== 'labels'}
                                          title="Højde af tekstlinier, målt i mm"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[13] = instance; }}
                    /></td>
                    <td><label htmlFor="fontSize" className={this.state.format === 'labels' ? '' : 'disabled'}>Fontstørrelse</label></td>
                    <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                          name="fontSize" id="fontSize" value={this.state.fontSize} disabled={this.state.format !== 'labels'}
                                          title="Fontstørrelse, målt i pixels (px)"
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true} hideErrorIfDisabled={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[14] = instance; }}
                    /></td>
                </tr>
                </tbody>
            </table>
        </div>
    }

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && field.props.disabled !== true && !field.isValid()) result = false;
        });
        return result;
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
        if (!this.state.clubChairman && !this.state.clubCashier && !this.state.clubItContact && !this.state.clubReleas && !this.state.sectionChairman && !this.state.sectionCashier && !this.state.members && !this.state.magazineByPost) errors.push('Vælg mindst en personkategori.');

        let options = Object.assign({}, {
            fromSection: this.state.fromSection === '' ? null : this.state.fromSection,
            toSection: this.state.toSection === '' ? null : this.state.toSection,
            fromClub: this.state.fromClub === '' ? null : this.state.fromClub,
            toClub: this.state.toClub === '' ? null : this.state.toClub,
            fromMember: this.state.fromMember === '' ? null : this.state.fromMember,
            toMember: this.state.toMember === '' ? null : this.state.toMember,
            showMemberNo: this.state.showMemberNo,
            showLogo: this.state.showLogo,
            clubChairman: this.state.clubChairman,
            clubCashier: this.state.clubCashier,
            clubItContact: this.state.clubItContact,
            clubReleas: this.state.clubReleas,
            sectionChairman: this.state.sectionChairman,
            sectionCashier: this.state.sectionCashier,
            members: this.state.members,
            magazineByPost: this.state.magazineByPost,
            format: this.state.format,
        }, this.state.format === 'labels' ? {
            leftMargin: this.state.leftMargin === '' ? null : Number(this.state.leftMargin),
            topMargin: this.state.topMargin === '' ? null : Number(this.state.topMargin),
            labelLeftMargin: this.state.labelLeftMargin === '' ? null : Number(this.state.labelLeftMargin),
            labelTopMargin: this.state.labelTopMargin === '' ? null : Number(this.state.labelTopMargin),
            labelHeight: this.state.labelHeight === '' ? null : Number(this.state.labelHeight),
            labelWidth: this.state.labelWidth === '' ? null : Number(this.state.labelWidth),
            rowCount: this.state.rowCount === '' ? null : Number(this.state.rowCount),
            columnCount: this.state.columnCount === '' ? null : Number(this.state.columnCount),
            lineHeight: this.state.lineHeight === '' ? null : Number(this.state.lineHeight),
            fontSize: this.state.fontSize === '' ? null : Number(this.state.fontSize),
        } : {});

        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        generalSection: state.admin.generalSection,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(GeneralLabels);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/GeneralLabels.js